import React from "react"
import { Select } from "antd"

const { Option } = Select

const stageOptions = [
  { value: "commitmentStageI", label: "Commitment Stage I" },
  { value: "commitmentStageII", label: "Commitment Stage II" },
  { value: "implementationStageI", label: "Implementation Stage I" },
  { value: "implementationStageII", label: "Implementation Stage II" },
]

const IndicatorFilters = ({ stage, setStage }) => {
  const handleStageChange = (value) => {
    const selectedOption = stageOptions.find(
      (option) => option.value === value,
    )
    setStage({
      value: selectedOption.value,
      label: selectedOption.label,
    })
  }

  const currentValue = typeof stage === "object" ? stage.value : stage

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginBottom: "20px",
        justifyContent: "center",
      }}
    >
      <Select
        placeholder="Select Stage"
        style={{ width: 200 }}
        onChange={handleStageChange}
        value={currentValue}
      >
        {stageOptions.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default IndicatorFilters
